import * as React from "react";
import { installBrowserBackGuard } from "../lib/browserBackGuard";

// enabled の間、ブラウザの戻る操作で画面を離れず onBack を呼ぶ。
export function useBrowserBackGuard(enabled: boolean, onBack: () => void): void {
  const onBackRef = React.useRef(onBack);
  onBackRef.current = onBack;

  React.useEffect(() => {
    if (!enabled || typeof window === "undefined") return;
    const userActivation = (navigator as Navigator & { userActivation?: { isActive: boolean } }).userActivation;
    return installBrowserBackGuard(window, () => onBackRef.current(), {
      hasUserActivation: userActivation?.isActive === true,
    });
  }, [enabled]);
}
